import { Map, fromJS } from 'immutable';
import { defaultContext } from "@biuwer/redux/src/config/constants";

/**
 * System DataPortals Reducer
 */

import {
    DATA_PORTALS_FETCH_REQUEST, DATA_PORTALS_FETCH_SUCCESS, DATA_PORTALS_FETCH_ERROR,
    DATA_PORTALS_INITIALIZE, DATA_PORTALS_LIST_INITIALIZE, DATA_PORTAL_DETAIL_INITIALIZE,
    DATA_PORTAL_FETCH_REQUEST, DATA_PORTAL_FETCH_SUCCESS, DATA_PORTAL_FETCH_ERROR,
    DATA_PORTAL_UPDATE_REQUEST, DATA_PORTAL_UPDATE_SUCCESS, DATA_PORTAL_UPDATE_ERROR,
    DATA_PORTAL_CHANGE_STATUS_REQUEST, DATA_PORTAL_CHANGE_STATUS_SUCCESS, DATA_PORTAL_CHANGE_STATUS_ERROR,
    DATA_PORTAL_CREATE_REQUEST, DATA_PORTAL_CREATE_SUCCESS, DATA_PORTAL_CREATE_ERROR,
    DATA_PORTAL_DELETE_REQUEST, DATA_PORTAL_DELETE_SUCCESS, DATA_PORTAL_DELETE_ERROR,
    DATA_PORTAL_URL_IS_AVAILABLE_REQUEST,
    DATA_PORTAL_URL_IS_AVAILABLE_SUCCESS,
    DATA_PORTAL_URL_IS_AVAILABLE_ERROR,
    DATA_PORTAL_CUSTOM_URL_VERIFY_REQUEST,
    DATA_PORTAL_CUSTOM_URL_VERIFY_SUCCESS,
    DATA_PORTAL_CUSTOM_URL_VERIFY_ERROR,
} from './data-portals-actions.js';

const initialState = fromJS({
    detail_primary: {},
    list_primary: {}
});

const dataPortals = (state = initialState, action) => {
    let newState, index = -1, listUpdatedPayload, detailUpdatedPayload;

    // Get list and detail context
    const list = `list_${(action && action.context) || defaultContext}`;
    const detail = `detail_${(action && action.context) || defaultContext}`;

    switch (action.type) {

        // Necessary to initialize dataPortals state prior to create a new dataPortals
        case DATA_PORTALS_INITIALIZE:
            newState = state
                .setIn([detail], Map({}))
                .setIn([list], Map({}));
            return newState;
        case DATA_PORTAL_DETAIL_INITIALIZE:
            newState = state
                .setIn([detail], Map({}));
            return newState;
        case DATA_PORTALS_LIST_INITIALIZE:
            newState = state
                .setIn([list], Map({}));
            return newState;

        // DataPortals fetch (list)
        case DATA_PORTALS_FETCH_REQUEST:
            newState = state;

            // DataPortals fetch request only use "list" options
            // Delete created, update, deleted keys if exists
            if (state.getIn([list, 'created'])) newState = newState.removeIn([list, 'created']);
            if (state.getIn([list, 'updated'])) newState = newState.removeIn([list, 'updated']);
            if (state.getIn([list, 'deleted'])) newState = newState.removeIn([list, 'deleted']);

            newState = newState
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case DATA_PORTALS_FETCH_SUCCESS:
            newState = state.mergeIn([list], Map({
                isFetching: action.isFetching,
                error: action.error,
                payload: fromJS(action.payload)
            }));
            return newState;
        case DATA_PORTALS_FETCH_ERROR:
            newState = state.mergeIn([list], Map({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage
            }));
            return newState;

        // DataPortal fetch (detail)
        case DATA_PORTAL_FETCH_REQUEST:

            newState = state;

            // DataPortal fetch request only use "detail" options
            // Delete created, update, deleted keys if exists
            if (state.getIn([detail, 'created'])) newState = newState.removeIn([detail, 'created']);
            if (state.getIn([detail, 'updated'])) newState = newState.removeIn([detail, 'updated']);
            if (state.getIn([detail, 'deleted'])) newState = newState.removeIn([detail, 'deleted']);

            newState = newState
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case DATA_PORTAL_FETCH_SUCCESS:
            newState = state.mergeIn([detail], Map({
                isFetching: action.isFetching,
                error: action.error,
                payload: fromJS(action.payload)
            }));
            return newState;
        case DATA_PORTAL_FETCH_ERROR:
            newState = state.mergeIn([detail], Map({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage,
                issue: action.issue,
                issuePayload: fromJS(action.issuePayload),
            }));
            return newState;
        case DATA_PORTAL_CREATE_REQUEST:

            newState = state;

            // Delete create key if exists
            if (state.getIn([detail, 'created'])) newState = newState.removeIn([detail, 'created']);
            if (state.getIn([list, 'created'])) newState = newState.removeIn([list, 'created']);

            newState = newState
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case DATA_PORTAL_CREATE_SUCCESS:

            // Update payload with new created dataPortal
            detailUpdatedPayload = fromJS(action.payload);

            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    created: action.created,
                    payload: detailUpdatedPayload
                }));

            if (state.getIn([list, 'payload'])) {
                listUpdatedPayload = state.getIn([list, 'payload']);
                listUpdatedPayload = listUpdatedPayload.push(fromJS(action.payload));

                newState = newState
                    .mergeIn([list], Map({
                        isFetching: action.isFetching,
                        error: action.error,
                        created: action.created,
                        payload: listUpdatedPayload
                    }));
            }

            return newState;
        case DATA_PORTAL_CREATE_ERROR:
            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    errorMessage: action.errorMessage
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    errorMessage: action.errorMessage
                }));
            return newState;

        // Update dataPortal and change dataPortal status
        case DATA_PORTAL_UPDATE_REQUEST:
        case DATA_PORTAL_CHANGE_STATUS_REQUEST:

            newState = state;

            // Check if "delete" key exists
            if (state.getIn([detail, 'delete'])) newState = newState.removeIn([detail, 'delete']);
            if (state.getIn([list, 'delete'])) newState = newState.removeIn([list, 'delete']);

            // Check if "updated" key exists
            if (state.getIn([detail, 'updated'])) newState = newState.removeIn([detail, 'updated']);
            if (state.getIn([list, 'updated'])) newState = newState.removeIn([list, 'updated']);

            newState = newState
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));

            return newState;
        case DATA_PORTAL_UPDATE_SUCCESS:
        case DATA_PORTAL_CHANGE_STATUS_SUCCESS:

            // Update payload with updated user
            detailUpdatedPayload = fromJS(action.payload);

            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    updated: action.updated,
                    payload: detailUpdatedPayload
                }));

            if (state.getIn([list, 'payload'])) {

                // Find the user index to be updated inside the List
                listUpdatedPayload = state.getIn([list, 'payload']);
                index = listUpdatedPayload.findIndex(item => item.get('_id') === action.payload._id);

                if (index >= 0) {
                    listUpdatedPayload = listUpdatedPayload.setIn([index], fromJS(action.payload));
                    newState = newState
                        .mergeIn([list], Map({
                            isFetching: action.isFetching,
                            error: action.error,
                            updated: action.updated,
                            payload: listUpdatedPayload
                        }));
                }
            }

            return newState;
        case DATA_PORTAL_UPDATE_ERROR:
        case DATA_PORTAL_CHANGE_STATUS_ERROR:
            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    errorMessage: action.errorMessage
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    errorMessage: action.errorMessage
                }));
            return newState;

        // Delete dataPortal
        case DATA_PORTAL_DELETE_REQUEST:
            newState = state
                .mergeIn([detail], Map({
                    delete: Map({
                        isFetching: action.isFetching,
                        error: action.error
                    })
                }))
                .mergeIn([list], Map({
                    delete: Map({
                        isFetching: action.isFetching,
                        error: action.error
                    })
                }));
            return newState;
        case DATA_PORTAL_DELETE_SUCCESS:

            // Update payload with deleted user
            detailUpdatedPayload = fromJS(action.payload);

            newState = state
                .mergeIn([detail], Map({
                    payload: detailUpdatedPayload,
                    delete: Map({
                        isFetching: action.isFetching,
                        error: action.error,
                        deleted: action.deleted
                    })
                }));

            if (state.getIn([list, 'payload'])) {

                // Find the user index to be updated inside the List
                listUpdatedPayload = state.getIn([list, 'payload']);
                index = listUpdatedPayload.findIndex(item => item.get('_id') === action.payload._id);

                if (index >= 0) {
                    listUpdatedPayload = listUpdatedPayload.removeIn([index]);

                    newState = newState
                        .mergeIn([list], {
                            payload: listUpdatedPayload,
                            delete: Map({
                                isFetching: action.isFetching,
                                error: action.error,
                                deleted: action.deleted
                            })
                        });
                }
            }
            return newState;
        case DATA_PORTAL_DELETE_ERROR:
            newState = state
                .mergeIn([detail], Map({
                    delete: Map({
                        isFetching: action.isFetching,
                        error: action.error,
                        errorMessage: action.errorMessage
                    })
                }))
                .mergeIn([list], Map({
                    delete: Map({
                        isFetching: action.isFetching,
                        error: action.error,
                        errorMessage: action.errorMessage
                    })
                }));
            return newState;

        case DATA_PORTAL_URL_IS_AVAILABLE_REQUEST:
            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case DATA_PORTAL_URL_IS_AVAILABLE_SUCCESS:
            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    urlIsAvailable: action.payload
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case DATA_PORTAL_URL_IS_AVAILABLE_ERROR:
            newState = state
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    errorMessage: action.errorMessage
                }))
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error,
                    errorMessage: action.errorMessage
                }));
            return newState;

        case DATA_PORTAL_CUSTOM_URL_VERIFY_REQUEST:
            newState = state.mergeIn([detail], Map({ customUrlVerification: Map({ isVerifying: true }) }));
            return newState;
        case DATA_PORTAL_CUSTOM_URL_VERIFY_SUCCESS:
            newState = state.mergeIn([detail], Map({
                customUrlVerification: fromJS({
                    isVerifying: false,
                    isValid: action.payload?.isValid,
                    customUrl: action.payload?.customUrl,
                    message: action.payload?.message
                })
            }));
            return newState;
        case DATA_PORTAL_CUSTOM_URL_VERIFY_ERROR:
            newState = state.mergeIn([detail], Map({
                customUrlVerification: fromJS({ isVerifying: false, isValid: false, customUrl: null, message: null })
            }));
            return newState;

        default:
            return state;
    }
};

export default dataPortals;